import LocalizedStrings from 'react-localization'

import Portuguese from '../lang/pt.json'
import English from '../lang/en.json'

export const localized = new LocalizedStrings({
  en: English,
  pt: Portuguese,
})
